import { getDefaultStore } from 'jotai';

import { authStateAtom } from '../atoms';

/**
 * Non-reactive boolean accessor for the cache's authenticated state.
 *
 * For module-level code, effects, and selectors that cannot subscribe.
 * Components should use `useIsAuthenticated().isAuthenticated` instead
 * for reactive updates.
 */
export function isAuthenticatedSync(): boolean {
  return getDefaultStore().get(authStateAtom) === 'authenticated';
}
